import { render, staticRenderFns } from "./BlockSubmission.vue?vue&type=template&id=473078b2&"
import script from "./BlockSubmission.vue?vue&type=script&lang=js&"
export * from "./BlockSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports